import { Component } from '@angular/core';
import { AnimationItem } from 'lottie-web';
import { AnimationOptions } from 'ngx-lottie';
import { BrandService } from '../brand/brand.service';

@Component({
  selector: 'app-new-loader',
  // standalone: true,
  // imports: [],
  templateUrl: './new-loader.component.html',
  styleUrl: './new-loader.component.css'
})
export class NewLoaderComponent {
  hasAnimation: boolean;
  options: AnimationOptions;

  constructor(private brandService: BrandService) {
    this.hasAnimation = !!this.brandService.brand.id;
    this.options = {
      path: this.brandService.brand.loaderAnimationPath,
      loop: true,
      autoplay: true
    };
  }

  animationCreated(animationItem: AnimationItem): void {
    console.log(animationItem);
  }

}
